/*
  Nische featured collection - "View all" reveal.

  The surplus cards are already in the page, hidden by a per-section CSS rule.
  Revealing them is one class toggle: no fetch, no reflow of the rest of the
  page, nothing to fail on a slow connection. Their images are loading="lazy"
  and a lazy image inside a display:none element is never requested, so nothing
  is downloaded until the shopper actually asks for it.

  Guarded and delegated on purpose. This file is emitted once per section, and
  the homepage carries more than one of these sections - without the guard the
  listener would be bound twice and every tap would open then immediately close
  the row.
*/
if (!window.NischeFeaturedCollection) {
  window.NischeFeaturedCollection = true;

  function nischeFcSetOpen(root, open) {
    var grid = root.querySelector('[data-nfc-grid]');
    if (grid) grid.classList.toggle('nfc-collapsed', !open);
    root.dataset.nfcState = open ? 'open' : 'closed';

    // Both placements are in the markup; CSS decides which one the current
    // breakpoint shows, so update them together.
    var links = root.querySelectorAll('[data-nfc-toggle]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var wrap = link.parentElement;
      var less = link.getAttribute('data-nfc-less');
      var more = link.getAttribute('data-nfc-more');

      if (open && !less) {
        wrap.hidden = true;
        continue;
      }

      wrap.hidden = false;
      link.querySelector('.nfc-va__label').textContent = open ? less : more;
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
      link.classList.toggle('nfc-va__link--open', open);
    }

    // A carousel does NOT recount on its own, and the two obvious reasons to
    // think it would are both wrong. Its ResizeObserver watches the <ul>, and
    // revealing display:none children changes that list's scrollWidth but not
    // its own border box, so the observer never fires. SliderComponent has no
    // window resize listener at all, so dispatching one - which is what this
    // used to do - reaches nothing.
    //
    // Left stale, slidesPerPage and totalPages still describe the collapsed
    // row: the counter reads the old total, and because the next button is
    // disabled by testing whether the LAST KNOWN slide is visible, it goes
    // disabled as soon as the last collapsed card is reached. The cards past
    // it are on the page and scrollable, but unreachable with the arrows -
    // which is the whole point of revealing them.
    //
    // resetPages() is Dawn's own method for this: it re-queries the slides,
    // recomputes the pages and repaints the controls.
    var sliders = root.querySelectorAll('slider-component');
    for (var s = 0; s < sliders.length; s++) {
      // Collapsing can leave a scrolled row parked on cards that are about to
      // disappear. Only the browser's own clamp would move it, and only if the
      // remaining cards no longer overflow - which on mobile they still do.
      if (!open) {
        var list = sliders[s].querySelector('[id^="Slider-"]');
        if (list) list.scrollLeft = 0;
      }
      if (typeof sliders[s].resetPages === 'function') sliders[s].resetPages();
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-nfc-toggle]');
    if (!link) return;

    var root = document.getElementById(link.getAttribute('data-nfc-toggle'));
    if (!root) return;

    // Only now: with JS off the link stays a plain link to the collection page.
    event.preventDefault();

    var open = root.dataset.nfcState !== 'open';
    nischeFcSetOpen(root, open);

    if (!open) {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}
